import React from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const n = (v) => Number(v || 0).toLocaleString();
const day = (d) => new Date(`${d}T00:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

function Stat({ label, value, testId, dark }) {
  return (
    <div className={`brut-card p-4 ${dark ? "bg-black text-white" : ""}`} data-testid={testId}>
      <div className={`label-mono ${dark ? "opacity-70" : ""}`}>{label}</div>
      <div className="mt-1 font-chivo text-3xl font-black">{value}</div>
    </div>
  );
}

export function GaTotals({ t }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      <Stat label="Visitors" value={n(t.visitors)} testId="ga-total-visitors" />
      <Stat label="Sessions" value={n(t.sessions)} testId="ga-total-sessions" />
      <Stat label="Thank-you views" value={n(t.thank_you_views)} testId="ga-total-thank-you" />
      <Stat label="Sessions reaching thank-you" value={`${(t.conversion_rate * 100).toFixed(1)}%`} testId="ga-total-rate" dark />
    </div>
  );
}

export function GaDailyChart({ rows }) {
  const data = rows.map((r) => ({ ...r, label: day(r.date) }));
  return (
    <section className="brut-card p-4" data-testid="ga-daily">
      <div className="mb-2 font-chivo text-lg font-black">Visitors and sessions by day</div>
      {!data.length ? <div className="label-mono p-6 text-center" data-testid="ga-daily-empty">No visits in this period yet.</div> : (
        <div className="h-72 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: -18 }}>
              <CartesianGrid stroke="#e4e4e7" vertical={false} />
              <XAxis dataKey="label" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip contentStyle={{ border: "1px solid #000", fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Line type="monotone" dataKey="visitors" name="Visitors" stroke="#2563eb" strokeWidth={2} dot={false} isAnimationActive={false} />
              <Line type="monotone" dataKey="sessions" name="Sessions" stroke="#0a0a0a" strokeWidth={2} dot={false} isAnimationActive={false} />
              <Line type="monotone" dataKey="thank_you_views" name="Thank-you views" stroke="#16a34a" strokeWidth={2} dot={false} isAnimationActive={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </section>
  );
}
